import type { AppDetail } from '../../api/types'
import { formatDate } from '../../lib/format'

export function VersionList({ versions }: { versions: AppDetail['versions'] }) {
	return (
		<section className="card">
			<h2>Versions</h2>
			{versions.length === 0 ? (
				<p className="muted">Version history starts with the first daily lookup.</p>
			) : (
				<div className="stack" style={{ gap: '0.75rem' }}>
					{versions.map((v) => (
						<div key={v.version}>
							<div className="row" style={{ justifyContent: 'space-between' }}>
								<strong>{v.version}</strong>
								<span className="muted small">{formatDate(v.releasedAt)}</span>
							</div>
							{v.releaseNotes && (
								<p
									className="small muted"
									style={{ margin: '0.25rem 0 0', whiteSpace: 'pre-line', maxHeight: '8rem', overflow: 'auto' }}
								>
									{v.releaseNotes}
								</p>
							)}
						</div>
					))}
				</div>
			)}
		</section>
	)
}
